import React, { Component } from 'react';
import { ErrorMessage } from 'formik';
import moment from 'moment';
import CurrencyInput from 'components/Input/currencyInput.component';
import Input from '../../../../../components/Input/input.component';
import { empenhoMask, numberMask } from '../../../../../components/Input/Masks';
import Required from '../../../../../components/Required/required.component';
import SelectMulti from '../../../../../components/SelectMulti/selectmulti.component';
import crepdecService from '../../../../../services/crepdecService';

export default class EditarHistoricoARP extends Component {
	constructor(props) {
		super(props);
		this.state = {
			crepdecs: [],
		};
	}

	async componentWillMount() {
		const responseCrepdec = await crepdecService.findAll();
		this.setState({ crepdecs: [...responseCrepdec.data] });
	}

	render() {
		const {
			props: {
				transacao,
				handleChange,
				setFieldValue,
			},
			state: {
				crepdecs,
			},
		} = this;
		return (
			<React.Fragment>
				<div className='row'>
					<div className='col-md-6'>
						<label>
							Número da ARP: <Required />
						</label>
						<div className='form-group'>
							<Input
								placeholder='0000/0000'
								mask={empenhoMask}
								type='input'
								name='destinoEstoque.numero'
								onChange={handleChange}
								value={transacao.destinoEstoque.numero}
							/>
							<ErrorMessage
								name='destinoEstoque.numero'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
					<div className='col-md-6'>
						<label>
							Validade: <Required />
						</label>
						<div className='form-group'>
							<Input
								type='date'
								max='9999-12-31'
								name='destinoEstoque.validade'
								onChange={handleChange}
								value={transacao.destinoEstoque.validade
									? moment(transacao.destinoEstoque.validade).format('YYYY-MM-DD') : undefined}
							/>
							<ErrorMessage
								name='destinoEstoque.validade'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
				</div>
				<div className='row'>
					<div className='col-md-12'>
						<label>
							CREPDEC(s) atendida(s): <Required />
						</label>
						<div className='form-group'>
							<SelectMulti
								isMulti
								uniqueKey='id'
								name='destinoEstoque.crepdecs'
								label='nome'
								// eslint-disable-next-line
								value={transacao.destinoEstoque.crepdecs.map(item => ({
									label: item.nome,
									value: item.id,
									object: {
										...item,
									},
								}))}
								onChange={(itens) => {
									setFieldValue('destinoEstoque.crepdecs', itens.map(item => item.object));
								}}
								options={crepdecs}
							/>
							<ErrorMessage
								name='destinoEstoque.crepdecs'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
				</div>

				<div className='row'>
					<div className='col-md-6'>
						<label>
							Quantidade: <Required />
						</label>
						<div className='form-group'>
							<Input
								type='text'
								mask={numberMask}
								name='quantidadeEntradaSaida'
								onChange={handleChange}
								value={transacao.quantidadeEntradaSaida}
								maxLength={18}
							/>
							<ErrorMessage
								name='quantidadeEntradaSaida'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
					<div className='col-md-6'>
						<label>
							Valor unitário: <Required />
						</label>
						<div className='form-group'>
							<div className='input-group-prepend'>
								<div className='input-group-text'>R$</div>
								<CurrencyInput
									name='destinoEstoque.valorUnitario'
									value={transacao.destinoEstoque.valorUnitario !== '' ? transacao.destinoEstoque.valorUnitario : null}
									handleChange={handleChange}
									precision='2'
								/>
							</div>
							<ErrorMessage
								name='destinoEstoque.valorUnitario'
								render={msg => (
									<span className='text-danger'>
										{msg}
									</span>
								)}
							/>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}
